import React from 'react'
import classnames from 'classnames'
import Link from 'gatsby-link'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

const UnsupportedPage = props => {
  const { classes } = props

  return (
    <div className={classnames(classes.errorPage, 'error404')}>
      <div className={classes.unsupported}>
        <div className={classes.contents}>
          <div className={classes.centred}>
            <Grid conatiner spacing={40}>
              <Grid item xs={12}>
                <Typography variant="display3">Sorry!</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subheading" gutterBottom={true}>
                  Right now this site doesn't work that great on older browsers, for the time being please try
                  on your mobile, <a href="https://www.google.co.uk/chrome/" target="_blank">chrome</a>, <a href="https://www.mozilla.org/en-GB/firefox/new/" target="_blank">firefox</a>, <a href="https://www.microsoft.com/en-gb/windows/microsoft-edge" target="_blank">edge</a> or <a href="https://support.apple.com/downloads/safari" target="_blank">safari</a>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  Many thanks
                </Typography>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(UnsupportedPage)



// WEBPACK FOOTER //
// ./src/components/unsupported/index.js